"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionEditorList = void 0;
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType/FormQuestionType"));
const createFormQuestion_1 = require("@opsbase/lib-form/mutations/createFormQuestion");
const createFormQuestionOption_1 = __importDefault(require("@opsbase/lib-form/mutations/createFormQuestionOption"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const Flag_1 = __importDefault(require("@opsbase/lib-issue/Flag/Flag"));
const IssueType_1 = require("@opsbase/lib-issue/IssueType/IssueType");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const react_markdown_1 = require("@opsbase/react-markdown");
const react_simple_reducer_1 = require("@opsbase/react-simple-reducer");
const useSysLang_1 = __importDefault(require("@opsbase/web-ctrl-syslang/SysLangController/useSysLang"));
const web_editablelist_1 = __importDefault(require("@opsbase/web-editablelist"));
const Divider_1 = __importDefault(require("@opsbase/web-layout/Divider"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const ColorPicker_1 = __importDefault(require("@opsbase/web-pickers/ColorPicker"));
const Checkbox_1 = __importDefault(require("@opsbase/web-ui/Checkbox"));
const react_1 = __importStar(require("react"));
const useFedActions_1 = __importDefault(require("../../FedController/useFedActions"));
const QuestionEditorConditionTreeButton_1 = __importDefault(require("../QuestionEditorConditionTreeButton"));
const QuestionEditorFailButton_1 = __importDefault(require("../QuestionEditorFailButton"));
const QuestionEditorIssueButton_1 = __importDefault(require("../QuestionEditorIssueButton"));
const QuestionEditorScoringButtonMenu_1 = __importDefault(require("../QuestionEditorScoringButtonMenu"));
const callbackReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { [action.key]: action.callback });
};
exports.QuestionEditorList = react_1.default.memo((props) => {
    const { scoring, config, onChange, immediateFailAvailable, qId, qTitle, disabled } = props;
    const { doExpand } = (0, useFedActions_1.default)();
    const { isAlt, language } = (0, useSysLang_1.default)();
    const [shouldExpand, setShouldExpand] = (0, react_1.useState)(false);
    const [value, setValue] = (0, react_1.useState)('');
    const [state, dispatch] = (0, react_1.useReducer)(react_simple_reducer_1.reducer, config);
    const [callbacks, callbackDispatch] = (0, react_1.useReducer)(callbackReducer, {});
    const items = isAlt
        ? state.options.map(o => {
            var _a;
            return ({
                id: o.id + language,
                rawId: o.id,
                title: ((_a = o.labelAlt) === null || _a === void 0 ? void 0 : _a[language]) || o.label,
            });
        })
        : state.options.map(o => ({ id: o.id + language, rawId: o.id, title: o.label }));
    (0, react_1.useEffect)(() => {
        if (state !== config) {
            onChange(state);
            if (shouldExpand) {
                doExpand(qId, true);
                setShouldExpand(false);
                setValue('');
            }
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state, value, shouldExpand]);
    const handleChange = (0, react_1.useCallback)(field => (newValue, fieldSuffix) => dispatch({ field: fieldSuffix ? `${field}.${fieldSuffix}` : field, value: newValue }), []);
    const handleChangeAllowMultiSelect = (0, react_1.useMemo)(() => handleChange('allowMultiSelect'), [handleChange]);
    const handleChangeOptions = (0, react_1.useMemo)(() => handleChange('options'), [handleChange]);
    const handleChangeLabel = (0, react_1.useCallback)(v => {
        const options = v.map(({ rawId, title }) => {
            const option = state.options.find(o => o.id === rawId) || (0, createFormQuestionOption_1.default)();
            if (isAlt) {
                option.labelAlt = Object.assign(Object.assign({}, option.labelAlt), { [language]: title });
                if (!option.label)
                    option.label = title;
            }
            else {
                option.label = title;
            }
            return option;
        });
        handleChangeOptions(options);
    }, [handleChangeOptions, isAlt, language, state]);
    const getOptionCallback = (0, react_1.useCallback)((prefix, option, fn) => {
        let c = callbacks[`${prefix}_${option.id}`];
        if (!c) {
            c = v => {
                const newOption = fn(option, v);
                handleChangeOptions(newOption, `'id=${newOption.id}'`);
            };
            callbackDispatch({ key: `${prefix}_${option.id}`, callback: c });
        }
        return c;
    }, [callbacks, handleChangeOptions]);
    const handleChangeFlag = (0, react_1.useCallback)((option, flag) => {
        option.flag = flag;
        return option;
    }, []);
    const handleChangeScore = (0, react_1.useCallback)((option, score) => {
        option.score = score;
        return option;
    }, []);
    const handleClickMarkFail = (0, react_1.useCallback)((option) => {
        option.fail = !option.fail;
        return option;
    }, []);
    const handleClickCondition = (0, react_1.useCallback)((option) => {
        var _a;
        const subQuestions = option.subQuestions;
        const enabled = subQuestions ? !subQuestions.enabled : false;
        //remove issue question if we are disabling
        const questions = subQuestions.questions
            ? enabled
                ? subQuestions.questions
                : ((_a = subQuestions.questions) === null || _a === void 0 ? void 0 : _a.filter(q => q.type !== FormQuestionType_1.default.ISSUE)) || []
            : [];
        option.subQuestions = {
            sqId: subQuestions ? subQuestions.sqId : '',
            enabled,
            questions,
        };
        setShouldExpand(true);
        if (option.subQuestions.enabled) {
            setValue(option.label);
        }
        return option;
    }, []);
    const handleClickAddIssueQuestion = (0, react_1.useCallback)((option) => {
        var _a, _b;
        const subQuestions = option.subQuestions;
        let questions = ((_a = subQuestions === null || subQuestions === void 0 ? void 0 : subQuestions.questions) === null || _a === void 0 ? void 0 : _a.filter(q => !!q.title)) || [];
        const isIssueQuestionFound = (_b = subQuestions.questions) === null || _b === void 0 ? void 0 : _b.some(q => q.type === FormQuestionType_1.default.ISSUE);
        if (!isIssueQuestionFound) {
            questions = questions.concat((0, createFormQuestion_1.createFormQuestion)({
                title: 'Please include details',
                type: FormQuestionType_1.default.ISSUE,
                config: {
                    [FormQuestionType_1.default.ISSUE]: {
                        title: 'Problem with ' + qTitle,
                        type: IssueType_1.DefaultIssueTypeKeys.UNSPECIFIED,
                        flag: Flag_1.default.RED,
                    },
                },
            }));
        }
        else {
            questions = questions.filter(q => q.type !== FormQuestionType_1.default.ISSUE);
        }
        option.subQuestions = {
            sqId: subQuestions ? subQuestions.sqId : '',
            enabled: subQuestions ? !subQuestions.enabled : false,
            questions: subQuestions ? questions || [] : [],
        };
        setShouldExpand(true);
        if (option.subQuestions.enabled) {
            setValue(option.label);
        }
        return option;
    }, [qTitle]);
    const handleBeforeItem = (0, react_1.useCallback)(({ rawId }) => {
        const option = state.options.find(o => o.id === rawId);
        return scoring ? (react_1.default.createElement(Pane_1.default, null,
            react_1.default.createElement(QuestionEditorScoringButtonMenu_1.default, { disabled: disabled, score: option.score, onChange: getOptionCallback('score', option, handleChangeScore) }))) : null;
    }, [state, scoring, disabled, getOptionCallback, handleChangeScore]);
    const handleAfterItem = (0, react_1.useCallback)(({ rawId }) => {
        var _a, _b, _c, _d;
        const option = state.options.find(o => o.id === rawId);
        return (react_1.default.createElement(Horizontal_1.default, null,
            react_1.default.createElement(ColorPicker_1.default, { disabled: disabled, noMargin: true, noBorder: true, value: option.flag, onChange: getOptionCallback('flag', option, handleChangeFlag) }),
            immediateFailAvailable && (react_1.default.createElement(QuestionEditorFailButton_1.default, { disabled: disabled, enable: option.fail, onClick: getOptionCallback('fail', option, handleClickMarkFail) })),
            react_1.default.createElement(QuestionEditorConditionTreeButton_1.default, { disabled: disabled, enable: ((_a = option === null || option === void 0 ? void 0 : option.subQuestions) === null || _a === void 0 ? void 0 : _a.enabled) ? option.subQuestions.enabled : false, isLabel: option.label && option.label !== '', onClick: getOptionCallback('condition', option, handleClickCondition) }),
            react_1.default.createElement(QuestionEditorIssueButton_1.default, { enable: ((_b = option === null || option === void 0 ? void 0 : option.subQuestions) === null || _b === void 0 ? void 0 : _b.enabled) &&
                    ((_d = (_c = option === null || option === void 0 ? void 0 : option.subQuestions) === null || _c === void 0 ? void 0 : _c.questions) === null || _d === void 0 ? void 0 : _d.some(q => q.type === FormQuestionType_1.default.ISSUE)), disabled: disabled, isLabel: (option === null || option === void 0 ? void 0 : option.label) && (option === null || option === void 0 ? void 0 : option.label) !== '', onClick: getOptionCallback('issue', option, handleClickAddIssueQuestion) })));
    }, [
        state,
        disabled,
        getOptionCallback,
        handleChangeFlag,
        immediateFailAvailable,
        handleClickMarkFail,
        handleClickCondition,
        handleClickAddIssueQuestion,
    ]);
    return (react_1.default.createElement(Vertical_1.default, null,
        react_1.default.createElement(web_editablelist_1.default, { disabled: disabled, items: items, canAddInline: !disabled, canAddAtBottom: !disabled, canReorder: !disabled, canDelete: !disabled, placeholder: lib_i18n_1.default.t('add-option'), onChange: handleChangeLabel, beforeItem: handleBeforeItem, afterItem: handleAfterItem }),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(Checkbox_1.default, { disabled: disabled, checked: state.allowMultiSelect, color: lib_palette_1.default.secondary, onChange: handleChangeAllowMultiSelect, label: (0, react_markdown_1.markdown)(lib_i18n_1.default.t('allow-multiple-selections')) })));
});
exports.default = exports.QuestionEditorList;
